import React, { useEffect, useState } from "react";
import { apiFetch } from "../api/api";
import MailboxTable from "../components/MailboxTable";
import MailboxForm from "../components/MailboxForm";

export default function Mailboxes() {
    const [mailboxes, setMailboxes] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [selectedMailbox, setSelectedMailbox] = useState(null);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        fetchMailboxes();
        fetchTenants();
    }, []);

    const fetchMailboxes = async () => {
        const data = await apiFetch("/mailboxes");
        setMailboxes(data);
    };

    const fetchTenants = async () => {
        const data = await apiFetch("/tenants");
        setTenants(data);
    };

    const handleCreateOrUpdate = async (data) => {
        if (selectedMailbox) {
            await apiFetch(`/mailboxes/${selectedMailbox.id}`, {
                method: "PATCH",
                body: JSON.stringify(data),
            });
        } else {
            await apiFetch("/mailboxes", {
                method: "POST",
                body: JSON.stringify(data),
            });
        }

        setShowForm(false);
        setSelectedMailbox(null);
        fetchMailboxes();
    };

    const handleDelete = async (id) => {
        await apiFetch(`/mailboxes/${id}`, {
            method: "DELETE",
        });

        fetchMailboxes();
    };

    const handleSendEmail = async (id) => {
        const confirmSend = window.confirm("Send email notification?");
        if (!confirmSend) return;

        await apiFetch(`/mailboxes/${id}/send-email`, {
            method: "POST",
        });

        fetchMailboxes();
    };
    return (
        <div>
            <h2>Mailboxes</h2>

            <button
                onClick={() => {
                    setSelectedMailbox(null);
                    setShowForm(true);
                }}
            >
                Add Mailbox
            </button>

            <MailboxTable
                mailboxes={mailboxes}
                onEdit={(mb) => {
                    setSelectedMailbox(mb);
                    setShowForm(true);
                }}
                onSendEmail={handleSendEmail}
                onDelete={handleDelete}
            />

            {showForm && (
                <MailboxForm
                    mailbox={selectedMailbox}
                    tenants={tenants}
                    onSubmit={handleCreateOrUpdate}
                    onCancel={() => {
                        setShowForm(false);
                        setSelectedMailbox(null);
                    }}
                />
            )}
        </div>
    );
}